<div class="flex f-fd--column">
  <div>
    <howden-page-title></howden-page-title>
  </div>

  <form [formGroup]="project.form">
    <div class="flex f-gap--10px" formGroupName="edit">
      <mat-card appearance="outlined">
        <mat-card-header class="flex f-jc--left">
          <mat-card-title i18n="@@app.sane-projects.edit.label">Datos Cliente</mat-card-title>
        </mat-card-header>

        <mat-card-content class="margin-top-10">
          <div class="flex f-gap--10px">
            <div class="f-basis--1 margin-top-10">
              <button
                mat-raised-button
                type="button"
                color="success"
                (click)="onSearch()"
                [disabled]="isEditMode"
                i18n="@@app.sane-projects.edit.searchClient"
              >
                Buscar Cliente/Candidato
              </button>
            </div>
            <mat-form-field class="f-basis--3" subscriptSizing="dynamic">
              <mat-label i18n="@@app.sane-projects.edit.label">Cliente</mat-label>
              <input matInput formControlName="projectClientName" [howdenControlError]="projectClientNameError" />
            </mat-form-field>

            <mat-form-field class="f-basis--2" subscriptSizing="dynamic">
              <mat-label i18n="@@app.sane-projects.edit.label">Fecha nacimiento</mat-label>
              <input
                matInput
                formControlName="projectClientBirthDate"
                [matDatepicker]="projectClientBirthDatePicker"
                [howdenControlError]="projectClientBirthDateError"
              />
              <mat-datepicker-toggle matSuffix [for]="projectClientBirthDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #projectClientBirthDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="f-basis--1" subscriptSizing="dynamic">
              <mat-label i18n="@@app.sane-projects.edit.label">Edad actuarial</mat-label>
              <input matInput formControlName="projectClientActuarialAge" [howdenControlError]="projectClientActuarialAgeError" />
            </mat-form-field>

            <mat-form-field class="f-basis--3" subscriptSizing="dynamic">
              <mat-label i18n="@@app.sane-projects.edit.label">Profesión</mat-label>
              <input matInput formControlName="projectClientProfession" [howdenControlError]="projectClientProfessionError" />
            </mat-form-field>

            <mat-form-field class="f-basis--2" subscriptSizing="dynamic">
              <mat-label i18n="@@app.sane-projects.edit.office">Oficina</mat-label>
              <input matInput formControlName="projectClientProvince" [howdenControlError]="projectClientProvinceError" />
            </mat-form-field>

            <mat-error #projectClientNameError></mat-error>
            <mat-error #projectClientBirthDateError></mat-error>
            <mat-error #projectClientActuarialAgeError></mat-error>
            <mat-error #projectClientProfessionError></mat-error>
            <mat-error #projectClientProvinceError></mat-error>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="flex f-gap--10px margin-top-25" formGroupName="edit">
      <mat-card appearance="outlined">
        <mat-card-header class="flex f-jc--left">
          <mat-card-title i18n="@@app.sane-projects.edit.label">Datos Programa</mat-card-title>
        </mat-card-header>

        <mat-card-content class="margin-top-10">
          <div class="flex f-gap--10px">
            <mat-form-field class="f-basis--4" subscriptSizing="dynamic">
              <mat-label i18n="@@app.sane-projects.edit.label">Nombre Programa</mat-label>
              <input
                matInput
                formControlName="projectName"
                [howdenControlError]="projectNameError"
                maxlength="255" />
              <mat-hint align="end">
                {{ project.form.get('edit.projectName')?.value?.length || 0 }}/255
              </mat-hint>
              <mat-error #projectNameError></mat-error>
            </mat-form-field>

            <mat-form-field class="f-basis--2" subscriptSizing="dynamic">
              <mat-label i18n="@@app.sane-projects.edit.label">Fecha Efecto</mat-label>
              <input
                matInput
                formControlName="projectEffectiveDate"
                [matDatepicker]="projectEffectiveDatePicker"
                [howdenControlError]="projectEffectiveDateError"
                [min]="!isEditMode ? minEffectiveDate : null" />
              <mat-datepicker-toggle matSuffix [for]="projectEffectiveDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #projectEffectiveDatePicker></mat-datepicker>
              <mat-error #projectEffectiveDateError></mat-error>
            </mat-form-field>

            <mat-form-field class="f-basis--2" subscriptSizing="dynamic">
              <mat-label i18n="@@app.sane-projects.edit.label">Forma Pago</mat-label>
              <mat-select formControlName="projectPaymentType" [howdenControlError]="projectPaymentTypeError" [compareWith]="compareByIdNumber">
                <mat-option [value]="null"></mat-option>
                @for (item of project.edit.paymentTypes; track item.id ?? $index) {
                  <mat-option [value]="item.id">{{ item.description }}</mat-option>
                }
              </mat-select>
              <mat-error #projectPaymentTypeError></mat-error>
            </mat-form-field>

            <mat-form-field class="f-basis--2" subscriptSizing="dynamic">
              <mat-label i18n="@@app.sane-projects.edit.label">Actividad</mat-label>
              <mat-select formControlName="projectActivity" [howdenControlError]="projectActivityError" [compareWith]="compareByIdNumber">
                <mat-option [value]="null"></mat-option>
                @for (item of project.edit.activities; track item.id ?? $index) {
                  <mat-option [value]="item.id">{{ item.description }}</mat-option>
                }
              </mat-select>
              <mat-error #projectActivityError></mat-error>
            </mat-form-field>

            <mat-form-field class="f-basis--3" subscriptSizing="dynamic">
              <mat-label i18n="@@app.sane-projects.edit.label">Deporte</mat-label>
              <mat-select formControlName="projectSport" [compareWith]="compareByIdNumber">
                <mat-option [value]="null"></mat-option>
                @for (s of project.edit.sports; track s.id ?? $index) {
                  <mat-option [value]="s.id">{{ s.description }}</mat-option>
                }
              </mat-select>
              @if (project.form.get('edit.projectSport')?.invalid) {
                <mat-error>Debes seleccionar un deporte</mat-error>
              }
            </mat-form-field>
          </div>

          @if (project.form.get('edit.projectIndustryLife')?.value) {
            <div class="flex f-gap--10px">
              <mat-form-field class="f-basis--2" subscriptSizing="dynamic">
                <mat-label i18n="@@app.sane-projects.edit.label">Fuerza Motriz</mat-label>
                <mat-select formControlName="projectLifeDrivingForce" [howdenControlError]="projectLifeDrivingForceError" [compareWith]="compareByIdNumber">
                  <mat-option [value]="null"></mat-option>
                  @for (item of project.edit.yesNoValues; track item.key ?? $index) {
                    <mat-option [value]="item.key">{{ item.value }}</mat-option>
                  }
                </mat-select>
                <mat-error #projectLifeDrivingForceError></mat-error>
              </mat-form-field>

              <mat-form-field class="f-basis--2" subscriptSizing="dynamic">
                <mat-label i18n="@@app.sane-projects.edit.label">Andamio / Tejado</mat-label>
                <mat-select formControlName="projectLifeScaffoldRoof" [howdenControlError]="projectLifeScaffoldRoofError" [compareWith]="compareByIdNumber">
                  <mat-option [value]="null"></mat-option>
                  @for (item of project.edit.yesNoValues; track item.key ?? $index) {
                    <mat-option [value]="item.key">{{ item.value }}</mat-option>
                  }
                </mat-select>
                <mat-error #projectLifeScaffoldRoofError></mat-error>
              </mat-form-field>

              <mat-form-field class="f-basis--2" subscriptSizing="dynamic">
                <mat-label i18n="@@app.sane-projects.edit.label">Riesgo Especiales</mat-label>
                <mat-select formControlName="projectLifeEspecialRisks" [howdenControlError]="projectLifeEspecialRisksError" [compareWith]="compareByIdNumber">
                  <mat-option [value]="null"></mat-option>
                  @for (item of project.edit.yesNoValues; track item.key ?? $index) {
                    <mat-option [value]="item.key">{{ item.value }}</mat-option>
                  }
                </mat-select>
                <mat-error #projectLifeEspecialRisksError></mat-error>
              </mat-form-field>

              <mat-form-field class="f-basis--2" subscriptSizing="dynamic">
                <mat-label i18n="@@app.sane-projects.edit.label">Moto</mat-label>
                <mat-select formControlName="projectLifeMotorbike" [howdenControlError]="projectLifeMotorbikeError" [compareWith]="compareByIdNumber">
                  <mat-option [value]="null"></mat-option>
                  @for (item of project.edit.motorbikes; track item.id ?? $index) {
                    <mat-option [value]="item.id">{{ item.description }}</mat-option>
                  }
                </mat-select>
                <mat-error #projectLifeMotorbikeError></mat-error>
              </mat-form-field>

              <div class="f-basis--4"></div>
            </div>
          }

          <div class="flex f-gap--10px margin-top-20 margin-bottom-15">
            <mat-slide-toggle class="f-basis--2" formControlName="projectIndustryLife" i18n="@@app.sane-projects.edit.label">Vida</mat-slide-toggle>
            <mat-slide-toggle class="f-basis--2" formControlName="projectIndustryAccident" i18n="@@app.sane-projects.edit.label">Accidentes</mat-slide-toggle>
            <mat-slide-toggle class="f-basis--2" formControlName="projectIndustryTemporaryIncapacity" i18n="@@app.sane-projects.edit.label">Incapacidad Temporal</mat-slide-toggle>
            <mat-slide-toggle class="f-basis--2" formControlName="projectIndustryDependency" i18n="@@app.sane-projects.edit.label">Dependencia</mat-slide-toggle>
            <mat-slide-toggle class="f-basis--2" formControlName="projectIndustryDeath" i18n="@@app.sane-projects.edit.label">Decesos</mat-slide-toggle>
          </div>

          <div class="flex">
            <h3 i18n="@@app.sane-projects.edit.projectGraphics">Datos para incorporar las Gráficas en el programa</h3>
          </div>

          <div class="flex f-gap--10px">
            <mat-form-field class="f-basis--3" subscriptSizing="dynamic">
              <mat-label i18n="@@app.sane-projects.edit.label">Nivel de Vida Cliente</mat-label>
              <mat-select formControlName="projectLivingStandard" [compareWith]="compareByIdNumber">
                <mat-option [value]="null"></mat-option>
                @for (lvl of project.edit.livingStandards; track lvl.id ?? $index) {
                  <mat-option [value]="lvl.id">{{ lvl.description }}</mat-option>
                }
              </mat-select>
              @if (project.form.get('edit.projectLivingStandard')?.invalid) {
                <mat-error>Debes seleccionar un nivel de vida</mat-error>
              }
            </mat-form-field>

            <mat-form-field class="f-basis--3" subscriptSizing="dynamic">
              <mat-label i18n="@@app.sane-projects.edit.label">Plazo IPT</mat-label>
              <mat-select formControlName="projectDeadlineIPT" [compareWith]="compareByIdNumber">
                <mat-option [value]="null"></mat-option>
                @for (d of project.edit.deadlineIPTs; track d.id ?? $index) {
                  <mat-option [value]="d.id">{{ d.description }}</mat-option>
                }
              </mat-select>
              @if (project.form.get('edit.projectDeadlineIPT')?.invalid) {
                <mat-error>Debes seleccionar un plazo IPT</mat-error>
              }
            </mat-form-field>

            <mat-form-field class="f-basis--3" subscriptSizing="dynamic">
              <mat-label i18n="@@app.sane-projects.edit.label">Cotización RETA</mat-label>
              <mat-select formControlName="projectContributionRETA" [compareWith]="compareByIdNumber">
                <mat-option [value]="null"></mat-option>
                @for (r of project.edit.contributionRETAs; track r.id ?? $index) {
                  <mat-option [value]="r.id">{{ r.description }}</mat-option>
                }
              </mat-select>
              @if (project.form.get('edit.projectContributionRETA')?.invalid) {
                <mat-error>Debes seleccionar una cotización RETA</mat-error>
              }
            </mat-form-field>

            <mat-form-field class="f-basis--3" subscriptSizing="dynamic">
              <mat-label i18n="@@app.sane-projects.edit.label">Cotización Régimen General</mat-label>
              <mat-select formControlName="projectContributionGeneralReg" [howdenControlError]="projectContributionGeneralRegError" [compareWith]="compareByIdNumber">
                <mat-option [value]="null"></mat-option>
                @for (g of project.edit.contributionGeneralRegs; track g.id ?? $index) {
                  <mat-option [value]="g.id">{{ g.description }}</mat-option>
                }
              </mat-select>
              <mat-error #projectContributionGeneralRegError></mat-error>
            </mat-form-field>
          </div>

          <div class="flex f-gap--10px">
            <mat-form-field class="f-basis--3" subscriptSizing="dynamic">
              <mat-label i18n="@@app.sane-projects.edit.label">Casad&#64;</mat-label>
              <mat-select formControlName="projectMarried" [compareWith]="compareByIdNumber">
                <mat-option [value]="null"></mat-option>
                @for (status of project.edit.maritalStatuses; track status.id ?? $index) {
                  <mat-option [value]="status.id">{{ status.description }}</mat-option>
                }
              </mat-select>
              <mat-error #projectMarriedError></mat-error>
            </mat-form-field>

            <mat-form-field class="f-basis--3" subscriptSizing="dynamic">
              <mat-label i18n="@@app.sane-projects.edit.label">Renta Mutuas</mat-label>
              <mat-select formControlName="projectMutualIncome" [howdenControlError]="projectMutualIncomeError" [compareWith]="compareByIdNumber">
                <mat-option [value]="null"></mat-option>
                @for (m of project.edit.mutualIncomes; track m.id ?? $index) {
                  <mat-option [value]="m.id">{{ m.description }}</mat-option>
                }
              </mat-select>
              <mat-error #projectMutualIncomeError></mat-error>
            </mat-form-field>

            <mat-form-field class="f-basis--3" subscriptSizing="dynamic">
              <mat-label i18n="@@app.sane-projects.edit.label">Hijos Menores</mat-label>
              <mat-select formControlName="projectMinorChildren" [compareWith]="compareByIdNumber">
                <mat-option [value]="null"></mat-option>
                @for (c of project.edit.children; track c.id ?? $index) {
                  <mat-option [value]="c.id">{{ c.description }}</mat-option>
                }
              </mat-select>
              <mat-error #projectMinorChildrenError></mat-error>
            </mat-form-field>

            <div class="f-basis--3"></div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </form>

  <div class="flex margin-top-25">
    <div class="flex f-basis--6 f-jc--center f-ai--center">
      <button mat-raised-button type="button" color="cancel" (click)="onCancel()">Cancelar</button>
    </div>
    <div class="flex f-basis--6 f-jc--center f-ai--center">
      <button
        mat-raised-button
        type="button"
        color="success"
        [disabled]="!canClickTariff"
        (click)="onAccept()">
        Generar Programa
      </button>
    </div>
  </div>
</div>
